import { Component, OnInit } from '@angular/core';

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'app-dettaglio-sole24-ore',
  templateUrl: './dettaglio-sole24-ore.component.html',
  styleUrls: ['./dettaglio-sole24-ore.component.css'],
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' },
})
export class DettaglioSole24OreComponent implements OnInit {

  constructor() { }

  html: any = null;
  titolo: any = null;

  ngOnInit() {
  }

  apriModale(html: any, titolo: any){
    this.html = html;
    this.titolo = titolo;
    openModal('dettaglio');
  }

  chiudiModale(){
    closeModal('dettaglio');
    this.html= null;
    this.titolo = null;
  }

}
